import React, { useState } from "react";
import { DialogProps, makeDialogOpener, useDialogSize, GridItem, Grid, PullRight, useDataLoader } from "@optimed/react";
import { Button, DialogContent, Table, TableLoadingRow, Tabs, toast } from "@optimed/react";
import { HisService, Service } from "../api/models";
import { mappingService, syncService } from "../api";
import { Identifier } from "./Identifier";
import { DoctorDocplannerLabel } from "./DoctorDocplannerLabel";
import { AddressLabel } from "./AddressLabel";
import { ServiceName } from "./ServiceName";

interface ServiceMappingDialogProps extends DialogProps<void> {
  hisService: HisService;
}

const tabs = [
  { id: 1, caption: "Wszyscy lekarze" },
  { id: 2, caption: "Powiązane z konkretnym lekarzem" },
];

export function ServiceMappingDialog(props: ServiceMappingDialogProps) {
  const { dialog } = props;
  useDialogSize("800px", "80%");

  const [selectedTab, setSelectedTab] = useState(tabs[0]);
  const [selectedDocplannerService, setSelectedDocplannerService] = useState<Service>();
  const [isAddressService, setIsAddressService] = useState<boolean>();
  const [services, servicesLoading] = useDataLoader(() => syncService.activeServices());
  const [doctors, doctorsLoading] = useDataLoader(() =>
    syncService.doctors().then(list => {
      return list.filter(x => x.docplanner).map(x => x.docplanner!);
    })
  );
  const onAccept = () => {
    if (!selectedDocplannerService) {
      toast.error("Nie wybrano procedury");
      return;
    }

    mappingService
      .postService({
        docplannerServiceId: isAddressService ? undefined : selectedDocplannerService.id,
        docplannerAddressServiceId: isAddressService ? selectedDocplannerService.id : undefined,
        hisServiceId: props.hisService.id.toString(),
      })
      .then(
        () => dialog.close(),
        () => toast.error("Błąd zapisu mapowania")
      );
  };

  return (
    <DialogContent header={"Ustaw mapowanie procedury " + props.hisService.nazwa}>
      <Grid>
        <GridItem rowTemplate="1fr" scrollable>
          <Tabs items={tabs} selected={selectedTab} onSelect={setSelectedTab} />
          <div hidden={selectedTab.id !== 1}>
            <Table>
              <tbody>
                <TableLoadingRow promise={servicesLoading} colSpan={2}></TableLoadingRow>
                {services?.map(service => (
                  <tr
                    key={service.id}
                    className={service === selectedDocplannerService ? "table-active" : undefined}
                    onClick={() => {
                      setSelectedDocplannerService(service);
                      setIsAddressService(false);
                    }}
                  >
                    <td>{service.name}</td>
                    <td>
                      <PullRight>
                        <Identifier value={service.id} />
                      </PullRight>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          <div hidden={selectedTab.id !== 2}>
            <Table>
              <tbody>
                <TableLoadingRow promise={doctorsLoading} colSpan={2}></TableLoadingRow>
                {doctors?.map(x => (
                  <>
                    <tr key={x.key}>
                      <td colSpan={2}>
                        <b>
                          <DoctorDocplannerLabel doctor={x} />
                        </b>
                        <br />
                        <small>
                          <AddressLabel address={x.address} />
                        </small>
                      </td>
                    </tr>

                    {x.services?.map(service => (
                      <tr
                        key={service.id}
                        className={service === selectedDocplannerService ? "table-active" : undefined}
                        onClick={() => {
                          setSelectedDocplannerService(service);
                          setIsAddressService(true);
                        }}
                      >
                        <td>
                          <ServiceName addressService={service} />
                        </td>
                        <td>
                          <PullRight>
                            <Identifier value={service.id} />
                          </PullRight>
                        </td>
                      </tr>
                    ))}
                  </>
                ))}
              </tbody>
            </Table>
          </div>
        </GridItem>
        <GridItem rowTemplate="auto" className="text-right">
          <Button text="Anuluj" onClick={dialog.cancel} />
          <Button text="Zatwierdź" disabled={!selectedDocplannerService} onClick={onAccept} />
        </GridItem>
      </Grid>
    </DialogContent>
  );
}

export const serviceMappingDialog = makeDialogOpener(ServiceMappingDialog);
